import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { FCVObject } from '../../../ProductOperation/CampaignBundleCrud/services/InsertFcvService'

export class AddLimitWithOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/addLimitWithOrder',
      requesterInfo,
    })
  }

  public async addLimitWithOrder(request: ILimitOrder): Promise<ILimitOrderResponse> {
    return await this.postAsync<ILimitOrderResponse>(request)
  }
}

export interface ILimitOrder {
  OrderNumber: string
  CompanyCode: string
  Kota?: string
}

export interface ILimitOrderResponse {
  DealerCode: string
  OrderNumber: string
  Price: number
  TLPrice: number
  Currency: string
}